import { useEffect } from "react";
import { useForm } from "@inertiajs/react";
import { handleDrawerSuccess, hasArrayErrors } from "@/lib/drawer-submission";
import { import_manage_products_path } from "@/routes";

export default function ProductImportDrawer({ errors = [], onSuccess, onProcessingChange }) {
  const { data, setData, post, processing } = useForm({ file: null });

  useEffect(() => {
    onProcessingChange?.(processing);
  }, [onProcessingChange, processing]);

  const submit = (event) => {
    event.preventDefault();
    post(import_manage_products_path(), {
      forceFormData: true,
      preserveScroll: true,
      onSuccess: (page) => handleDrawerSuccess(
        page,
        (props) => props.show_import_product_drawer || hasArrayErrors(props, "import_errors"),
        onSuccess
      )
    });
  };

  return (
    <form className="vstack gap-4" onSubmit={submit}>
      <p className="mb-0">
        Importér en JSON-fil fra et andet miljø. Produktet oprettes som et nyt produkt i det globale katalog
        med samme navn, beskrivelser, trin, undertrin og involverede.
      </p>
      <p className="text-muted mb-0">
        Organisationer, filer, vejledninger og skabeloner medtages ikke. Eksisterende produkter ændres ikke.
      </p>

      {errors.length > 0 && (
        <div className="alert alert-danger mb-0" role="alert">
          {errors.join(", ")}
        </div>
      )}

      <div>
        <label className="form-label fw-semibold" htmlFor="product-import-file">JSON-fil</label>
        <input
          id="product-import-file"
          type="file"
          className="form-control"
          accept=".json,application/json"
          aria-describedby="product-import-file-help"
          required
          disabled={processing}
          onChange={(event) => setData("file", event.target.files?.[0] || null)}
        />
        <div id="product-import-file-help" className="form-text">Vælg en eksporteret produktfil på højst 5 MB.</div>
      </div>

      <div className="d-flex justify-content-end">
        <button type="submit" className="btn btn-primary" disabled={processing || !data.file}>
          {processing ? "Importerer…" : "Importér produkt"}
        </button>
      </div>
    </form>
  );
}
